<template>
  <Layout>
    <div v-if="shipment" class="container manifest">
      <h2 class="">Ship Manifest</h2>
      <p >{{ client.firstName + ' ' + client.lastName }}</p>
      <p v-if="pendingItems" class="d-print-none">
        {{ message }}<br>
        <button class="btn btn-outline-light mt-4" @click="print">Print</button>
      </p>
    </div>
    <div :class="printClass">
      <print @printDataUpdated="updatedQuotes"></print>
    </div>
  </Layout>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import Layout from '@/router/layouts/main'
import VueHtmlToPaper from 'vue-html-to-paper'
import Vue from 'vue'
import Print from './print'

Vue.use(VueHtmlToPaper)

export default {
  name: 'manifest',
  components: {
    Print, Layout, VueHtmlToPaper
  },
  data () {
    return {
      shipment: '',
      pendingItems: [],
      placeholderImgUrl: require('@/assets/images/knot.svg'),
      printClass: 'd-none',
      stylist: this.$store.state.stylist
    }
  },
  methods: {
    updatedQuotes (responseArray) {
      this.shipment = responseArray.data
      this.pendingItems = responseArray.included
    },
    print () {
      this.printClass = 'd-block'
      const options = {
        styles: [
          '/print.css'
        ]
      }
      this.$htmlToPaper('print-manifest', options, () => {
        this.printClass = 'd-none'
      })
    }
  },
  computed: {
    content () {
      return this.$store.state.il8nContent
    },
    clients () {
      return this.$store.state.clients
    },
    message () {
      const data = {
        numberOfItems: this.pendingItems.length,
        clientName: this.client.firstName
      }
      return this.$helpers.dynamicContent(this.content['whiteGlove.print'], data)
    },
    client () {
      return this.clients.find(client => client.id === this.shipment.attributes.clientId)
    }
  }
}
</script>
<style scoped>
  .manifest {
    color: #FFF;
  }
</style>
